import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { from, Observable, throwError } from "rxjs";
import { ApiService } from "../services/api.service";
import { Router } from "@angular/router";
import { catchError, switchMap } from "rxjs/operators";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private api: ApiService, private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Convertemos a obtenção do token para um Observable
    return from(this.getToken()).pipe(
      switchMap((token) => {
        if (token) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          });
        }
        return next.handle(request).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.handleUnauthorizedError();
            }
            return throwError(() => error);
          })
        );
      })
    );
  }

  private async getToken(): Promise<string | null> {
    const authData = this.api.isAuthenticated.getValue();
    if (authData?.authenticated) {
      return authData.token;
    }

    // Se não tiver no BehaviorSubject, tenta carregar do Storage
    const token = await this.api.loadTokenFromStorage();
    return token;
  }

  private handleUnauthorizedError(): void {
    this.api.logout();
    this.router.navigate(["/login"]);
  }
}
